// 운행설정 대상
export const targetType = {
    HUB: 'hub',
    STORE: 'store',
};
/** 운행설정 종류 */
export const operationSettingType = {
    /** 설정할증 */
    APPLY_IRREGULAR_SURCHARGE: 'APPLY_IRREGULAR_SURCHARGE',
    /** 대행료추가할증 */
    IRREGULAR_SURCHARGE: 'IRREGULAR_SURCHARGE',
    /** 배달수행상황 */
    DELIVERY_STATUS: 'DELIVERY_STATUS',
};
/** 지연 사유 */
export const delayReasonType = {
    BAD_WEATHER: 'BAD_WEATHER',
    OVER_CAPACITY: 'OVER_CAPACITY',
    RIDER_ACCIDENT: 'RIDER_ACCIDENT',
    ETC: 'ETC',
};
/** 운행설정 결과 (를 이용해 상태를 추가계산함) */
export const processResult = {
    R: 'R',
    P: 'P',
    O: 'O',
    X: 'X',
    A: 'A',
};
/** 운행설정 상태 */
export const processStatus = {
    CHECKING: 'CHECKING',
    IN_PROCESS: 'IN_PROCESS',
    COMPLETED: 'COMPLETED',
    REFUSED: 'REFUSED',
};
/** 운행설정 유형 */
export const processType = {
    /** 설정할증 적용 */
    APPLY_CONFIG_SURCHARGE: 'APPLY_CONFIG_SURCHARGE',
    /** 설정할증 해제 */
    RELEASE_CONFIG_SURCHARGE: 'RELEASE_CONFIG_SURCHARGE',
    /** 추가할증금액 변경 */
    CHANGE_IRREGULAR_SURCHARGE: 'CHANGE_IRREGULAR_SURCHARGE',
    /** 중단 적용 */
    PAUSE_DELIVERY: 'PAUSE_DELIVERY',
    /** 중단 해제 */
    ON_DELIVERY: 'ON_DELIVERY',
    /** 지연시간 변경 */
    CHANGE_DELAY_TIME: 'CHANGE_DELAY_TIME',
    /** 기타 */
    ETC: 'ETC',
};
